import axios, { AxiosRequestConfig } from 'axios';
import Constants from '../utils/constants';
import {
  getLocalRefreshToken,
  setLocalAccessToken,
  setLocalIDToken,
  setLocalRefreshToken,
} from '../utils/storageUtil';

const MAX_RETRY_NUMBER = 3;
let retryCount = 0;
const logOut = () => {
  setLocalRefreshToken('');
  setLocalAccessToken('');
  setLocalIDToken('');
  window.location.replace('/');
};
class HttpService {
  // GET method
  async get(url: string, headers: any, params?: any): Promise<any> {
    if (params) {
      const queryString = new URLSearchParams(params).toString();
      url = url + '?' + queryString;
    }
    try {
      const response = await axios.get(url, headers);
      return response.data;
    } catch (error: any) {
      if (error.status === 401) {
        const responseData = await this.refreshToken();
        if (responseData) {
          console.log(responseData);

          return await this.get(
            url,
            { headers: { Authorization: 'Bearer ' + responseData } },
            null
          );
        }
        // window.location.href = "/"; //
      }
      console.error('Error during GET request:', error);
      throw error;
    }
  }
  //delete method
  async delete(url: string, headers: any, params?: any): Promise<any> {
    if (params) {
      const queryString = new URLSearchParams(params).toString();
      url = url + '?' + queryString;
    }
    try {
      const response = await axios.delete(url, headers);
      return response.data;
    } catch (error: any) {
      console.error('Error during DELETE request:', error);
      throw error;
    }
  }
  // POST method
  async postWithFileUpload(url: string, data: any, options: any): Promise<any> {
    try {
      const response = await axios.post(url, data, options);
      return response.data;
    } catch (error: any) {
      console.error('Error during GET request:', error);
      throw error;
    }
  }
  // POST method
  async s3Upload(url: string, fields: any, options: any): Promise<any> {
    try {
      const data = new FormData();
      data.append('key', fields.key);
      data.append('bucket', fields.bucket);
      data.append('X-Amz-Algorithm', fields['X-Amz-Algorithm']);
      data.append('X-Amz-Credential', fields['X-Amz-Credential']);
      data.append('X-Amz-Date', fields['X-Amz-Date']);
      data.append('X-Amz-Security-Token', fields['X-Amz-Security-Token']);
      data.append('Policy', fields.Policy);
      data.append('X-Amz-Signature', fields['X-Amz-Signature']);
      data.append('file', fields.file);
      const response = await axios.post(url, data, options);
      return response;
    } catch (error: any) {
      console.error('Error during Upload request:', error);
      throw error;
    }
  }
  // S3 Upload Signed URL method
  handlePresignedURL = async (
    file: any,
    relationType: any,
    relationId: any,
    token: string
  ) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (file) {
          const headers = {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          };
          const fileName = file.name;
          const response = await axios.post(
            `${Constants.apiURL}${Constants.documentMediaURL}/uploadFileSignedURL`,
            { relationType, relationId, fileName },
            headers
          );

          if (response.data.data) {
            const PresignedResponseData = response.data.data;
            const fields = PresignedResponseData.fields;
            fields['file'] = file;
            const url = PresignedResponseData.url;
            const responseDatas3Upload = await this.s3Upload(url, fields, {
              headers: { enctype: 'multipart/form-data' },
            });
            console.log(responseDatas3Upload);
            if (responseDatas3Upload) {
              await this.post(
                Constants.apiURL + Constants.documentMediaURL,
                {
                  relationId,
                  relationType,
                  fileName: PresignedResponseData.fileName,
                  filePath: PresignedResponseData.filePath,
                },
                headers
              );
              resolve(true);
            }
          } else {
            resolve(false);
          }
          console.log('GET Response:', response);
        }
      } catch (error) {
        resolve(false);

        console.error('Error fetching data:', error);
      }
    });
  };

  handlePresignedDocument = async (
    file: any,
    type: any,
    id: any,
    token: string,
    url?: string
  ) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (file) {
          const headers = {
            headers: {
              Authorization: 'Bearer ' + token,
            },
          };
          let apiUrl: any = `${Constants.apiURL}${Constants.documentURL}/${type}/uploadSignedURL`;
          if (url) {
            apiUrl = url;
          }
          const fileName = file.name
            ? file.name
            : 'loumac_' + new Date().getTime() + '.png';
          const response = await axios.post(apiUrl, { id, fileName }, headers);

          if (response.data.data) {
            const PresignedResponseData = response.data.data;
            const fields = PresignedResponseData.fields;
            fields['file'] = file;
            const url = PresignedResponseData.url;
            const responseDatas3Upload = await this.s3Upload(url, fields, {
              headers: { enctype: 'multipart/form-data' },
            });
            console.log(responseDatas3Upload);

            resolve(PresignedResponseData);
          } else {
            resolve(false);
          }
          console.log('GET Response:', response);
        }
      } catch (error) {
        resolve(false);

        console.error('Error fetching data:', error);
      }
    });
  };

  // POST method
  async post(
    url: string,
    data: any,
    options: AxiosRequestConfig
  ): Promise<any> {
    try {
      const response = await axios.post(url, data, options);
      return response.data;
    } catch (error: any) {
      if (error.status === 401) {
        const responseData = await this.refreshToken();
        if (responseData) {
          const optionData = {
            headers: { Authorization: 'Bearer ' + responseData },
          };
          return await this.post(url, data, optionData);
        }
      }
      console.error('Error during GET request:', error);
      throw error;
    }
  }

  // PUT method
  async put(url: string, data: any, headers: any): Promise<any> {
    try {
      const response = await axios.put(url, data, headers);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Error: ${response.status}`);
      }
    } catch (error: any) {
      if (error.status === 401) {
        const responseData = await this.refreshToken();
        if (responseData) {
          const optionData = {
            headers: { Authorization: 'Bearer ' + responseData },
          };
          return await this.put(url, data, optionData);
        }
      }
      console.error('Error during GET request:', error);
      throw error;
    }
  }
  //PATCH method
  async patch(url: string, data: any, headers: any): Promise<any> {
    try {
      const response = await axios.patch(url, data, headers);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Error: ${response.status}`);
      }
    } catch (error: any) {
      if (error.status === 401) {
        const responseData = await this.refreshToken();
        if (responseData) {
          const optionData = {
            headers: { Authorization: 'Bearer ' + responseData },
          };
          return await this.patch(url, data, optionData);
        }
      }
      console.error('Error during GET request:', error);
      throw error;
    }
  }

  async refreshToken() {
    return new Promise((resolve, reject) => {
      const refreshToken = getLocalRefreshToken();
      if (refreshToken === '' || refreshToken === null) {
        logOut();
      }
      axios({
        url: Constants.apiURL + Constants.REFRESH_TOKEN_URL,

        method: 'POST',
        data: {
          AuthParameters: {
            REFRESH_TOKEN: refreshToken,
          },
        },
      } as any)
        .then((response) => {
          console.log(response);
          if (
            response.data &&
            response.data.accessToken &&
            response.data.idToken
          ) {
            const { accessToken } = response.data;
            setLocalAccessToken(accessToken);
            if (retryCount < MAX_RETRY_NUMBER) {
              retryCount++;
              return resolve(accessToken);
            } else {
              return resolve(null);
            }
          } else {
            console.log('1');
            logOut();
          }
        })
        .catch((e) => {
          console.log('2');
          logOut();
        });
    });
  }
  getMediaRecord = async (id: any, token: string) => {
    return new Promise(async (resolve, reject) => {
      const response = await this.get(
        Constants.apiURL + Constants.documentMediaURL + '/signedURL/' + id,
        { headers: { Authorization: 'Bearer ' + token } },
        null
      );
      if (response.success) {
        resolve(response.data);
      } else {
        resolve(null);
      }
    });
  };
  handleDownloadFile = async (ID: any, token: any) => {
    const media: any = await this.getMediaRecord(ID, token);
    if (media) {
      window.open(media, '_blank');
    }
  };
}

const HttpServices = new HttpService();
export default HttpServices;
